import React, { useState, useEffect } from 'react'
import { Link } from 'react-router-dom'
import { LoaderSpinner } from '../../components/LoaderSpinner';
import Swal from 'sweetalert2';


// redux
import { useSelector, useDispatch } from 'react-redux';

import { obtenerCampaign, actualizarCampaign } from '../../actions/campaignsActions';
import $ from 'jquery'
import { BreadCrumbCampaign } from '../../components/BreadCrumbCampaign';

export const EditCampaign = () => {

    const dispatch = useDispatch()
    const loading = useSelector( state => state.campaigns.loading )
    const campaignSearch = useSelector( state => state.campaigns.campaignedit )

    const search_custom_page = useSelector( state => state.landings.search_custom_page )

    const [campaignId ,setCampaignId] = useState(null);

    const [ campaign, setCampaign ] = useState({
        nombre:'',
        asunto:'',
        remitente:'',
        email_remitente:''
    })

    const [isAbTest, setIsAbTest] = useState(false)
    const [abConfig, setAbConfig] = useState({
        ab_variable_type: 'subject',
        subject_a: '',
        subject_b: '',
        test_sample_percentage: 20,
        winning_metric: 'open_rate',
        wait_time_hours: 24
    })

    const handleAbConfigChange = (e) => {
        const { name, value } = e.target
        setAbConfig(prev => ({
            ...prev,
            [name]: name === 'test_sample_percentage' || name === 'wait_time_hours'
                ? Number(value)
                : value
        }))
    }

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (campaign.nombre.trim() === '' || campaign.remitente.trim() === '' || campaign.email_remitente.trim() === '') {
            Swal.fire({ icon:'error', title:'Hubo un error', text:'Nombre, remitente y email remitente son obligatorios' })
            return;
        }

        if (!isAbTest) {
            if (campaign.asunto.trim() === '') {
                Swal.fire({ icon:'error', title:'Hubo un error', text:'El asunto es obligatorio' })
                return;
            }
            await dispatch(actualizarCampaign(campaign));
            return;
        }

        // A/B validation
        if (abConfig.subject_a.trim() === '') {
            Swal.fire({ icon:'error', title:'Hubo un error', text:'El Asunto A es obligatorio' })
            return;
        }
        if (abConfig.subject_b.trim() === '') {
            Swal.fire({ icon:'error', title:'Hubo un error', text:'El Asunto B es obligatorio' })
            return;
        }
        if (abConfig.subject_a.trim() === abConfig.subject_b.trim()) {
            Swal.fire({ icon:'error', title:'Hubo un error', text:'El Asunto A y el Asunto B no pueden ser iguales' })
            return;
        }
        if (abConfig.test_sample_percentage < 10 || abConfig.test_sample_percentage > 50) {
            Swal.fire({ icon:'error', title:'Hubo un error', text:'El porcentaje de muestra debe estar entre 10 y 50' })
            return;
        }
        if (abConfig.wait_time_hours < 1 || abConfig.wait_time_hours > 72) {
            Swal.fire({ icon:'error', title:'Hubo un error', text:'El tiempo de espera debe estar entre 1 y 72 horas' })
            return;
        }

        const payload = {
            ...campaign,
            asunto: abConfig.subject_a,
            is_ab_test: true,
            ab_variable_type: abConfig.ab_variable_type,
            test_sample_percentage: abConfig.test_sample_percentage,
            winning_metric: abConfig.winning_metric,
            wait_time_hours: abConfig.wait_time_hours,
            ab_variants: [
                { variant_key: 'A', subject: abConfig.subject_a },
                { variant_key: 'B', subject: abConfig.subject_b }
            ]
        }

        await dispatch(actualizarCampaign(payload));
    }

    const handleChange = (e) => {
        setCampaign({
            ...campaign,
            [e.target.name] : e.target.value
        })
    }

    useEffect(()=>{
        const idTrozos = window.location.pathname.split('/');
        if(idTrozos.length === 3){
            setCampaignId(idTrozos[2]);
        }
        if(campaignId && campaignSearch === null){
            console.log('campaignId',campaignId)
            dispatch(obtenerCampaign(campaignId))
        }
        if(campaignSearch){
            setCampaign(campaignSearch);

            // Pre-fill A/B fields if the campaign is already an A/B test
            if (campaignSearch.is_ab_test) {
                setIsAbTest(true)
                const variantA = campaignSearch.ab_variants && campaignSearch.ab_variants.find(v => v.variant_key === 'A')
                const variantB = campaignSearch.ab_variants && campaignSearch.ab_variants.find(v => v.variant_key === 'B')
                setAbConfig({
                    ab_variable_type: campaignSearch.ab_variable_type || 'subject',
                    subject_a: variantA ? variantA.subject : '',
                    subject_b: variantB ? variantB.subject : '',
                    test_sample_percentage: campaignSearch.test_sample_percentage || 20,
                    winning_metric: campaignSearch.winning_metric || 'open_rate',
                    wait_time_hours: campaignSearch.wait_time_hours || 24
                })
            }
        }

        if(search_custom_page == null){
            $('#loading').hide();
        }

    },[campaignId,campaignSearch,search_custom_page])

    return (
        <div className="white_box QA_section card_height_100">
            <div className="p-4">
            <BreadCrumbCampaign active={1}/>

                <span className="mr-3 naranja">Editar Campaña</span>
                <Link to="/mail_marketing" className="btn btn-link float-right colorsito" >Volver</Link>
                {
                    loading ? <LoaderSpinner/> : null
                }
                <form onSubmit={ handleSubmit } className="mt-5">
                    <div className="row">
                        <div className="col-md-4">
                            <div className="form-group">
                                <label>Nombre</label>
                                <input type="text" className="form-control-lg form-control" value={ campaign.nombre } onChange={ handleChange } name="nombre" placeholder="Nombre" />
                            </div>
                        </div>
                    </div>

                    {!isAbTest && (
                        <div className="row">
                            <div className="col-md-4">
                                <div className="form-group">
                                    <label>Asunto</label>
                                    <input type="text" className="form-control-lg form-control" value={ campaign.asunto } onChange={ handleChange } name="asunto" placeholder="Asunto"/>
                                </div>
                            </div>
                        </div>
                    )}

                    <div className="row">
                        <div className="col-md-4">
                            <div className="form-group">
                                <label>Nombre Remitente</label>
                                <input type="text" className="form-control-lg form-control" value={ campaign.remitente } onChange={ handleChange } name="remitente" placeholder="Nombre Remitente" />
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-4">
                            <div className="form-group">
                                <label>Email Remitente</label>
                                <input type="email" className="form-control-lg form-control" value={ campaign.email_remitente } onChange={ handleChange } name="email_remitente" placeholder="Email Remitente"/>
                            </div>
                        </div>
                    </div>

                    {/* A/B Test toggle */}
                    <div className="row mt-3">
                        <div className="col-md-6">
                            <div className="form-group d-flex align-items-center">
                                <label className="mb-0 mr-3" style={{fontWeight:'500'}}>¿Deseas realizar una prueba A/B?</label>
                                <div className="custom-control custom-switch">
                                    <input
                                        type="checkbox"
                                        className="custom-control-input"
                                        id="abTestSwitch"
                                        checked={isAbTest}
                                        onChange={e => setIsAbTest(e.target.checked)}
                                    />
                                    <label className="custom-control-label" htmlFor="abTestSwitch"></label>
                                </div>
                            </div>
                        </div>
                    </div>

                    {isAbTest && (
                        <div className="row mt-2">
                            <div className="col-md-8">
                                <div className="card border" style={{borderRadius:'8px'}}>
                                    <div className="card-body">
                                        <h6 className="naranja mb-4" style={{fontWeight:'600'}}>Configuración A/B</h6>

                                        <div className="form-group">
                                            <label>Asunto — Variante A</label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                name="subject_a"
                                                value={abConfig.subject_a}
                                                onChange={handleAbConfigChange}
                                                placeholder="Asunto para Variante A"
                                            />
                                        </div>

                                        <div className="form-group">
                                            <label>Asunto — Variante B</label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                name="subject_b"
                                                value={abConfig.subject_b}
                                                onChange={handleAbConfigChange}
                                                placeholder="Asunto para Variante B"
                                            />
                                        </div>

                                        <div className="form-group">
                                            <label>Tamaño de muestra: <strong>{abConfig.test_sample_percentage}%</strong></label>
                                            <input
                                                type="range"
                                                className="form-control-range"
                                                name="test_sample_percentage"
                                                min="10"
                                                max="50"
                                                step="5"
                                                value={abConfig.test_sample_percentage}
                                                onChange={handleAbConfigChange}
                                            />
                                            <div className="d-flex justify-content-between">
                                                <small className="text-muted">10%</small>
                                                <small className="text-muted">50%</small>
                                            </div>
                                        </div>

                                        <div className="form-group">
                                            <label>Métrica ganadora</label>
                                            <select
                                                className="form-control"
                                                name="winning_metric"
                                                value={abConfig.winning_metric}
                                                onChange={handleAbConfigChange}
                                            >
                                                <option value="open_rate">Tasa de apertura</option>
                                                <option value="click_rate">Tasa de clics</option>
                                            </select>
                                        </div>

                                        <div className="form-group">
                                            <label>Tiempo de espera (horas)</label>
                                            <input
                                                type="number"
                                                className="form-control"
                                                name="wait_time_hours"
                                                min="1"
                                                max="72"
                                                value={abConfig.wait_time_hours}
                                                onChange={handleAbConfigChange}
                                            />
                                            <small className="text-muted">Entre 1 y 72 horas</small>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}

                    <input type="submit" className="btn btn-primary mt-4" value="Actualizar"/>
                </form>
            </div>

        </div>
    )
}
